import { Http } from '@pirates/not-morty-biz';
import {
  CostCenterQueryParams,
  CostCenter,
  CreateCostCenterPayload,
  AddDriverPayload,
  PatchCostCenterPayload,
  CostCenterDriver,
  CostCenterApiDataWrapper,
} from './cost-centers.model';
import { removeFalsyElements } from '@/utils/validation';

export class CostCentersService {
  private urlPath = '/api/b2b/cost-centers/v1/customer/cost-centers';
  async getCostCenters(params: CostCenterQueryParams) {
    const response = await Http.get<{ data: CostCenter[]; meta: { total: number } }>(this.urlPath, { params });
    return response;
  }

  async createCostCenter(payload: CreateCostCenterPayload) {
    const response = await Http.post<CostCenterApiDataWrapper<CostCenter>>(this.urlPath, payload);

    return response.data;
  }

  async deleteCostCenter(groupHref: string) {
    await Http.delete(groupHref);
  }

  async patchCostCenter(groupHref: string, payload: PatchCostCenterPayload) {
    const response = await Http.patch<CostCenterApiDataWrapper<CostCenter>>(groupHref, payload);

    return response.data;
  }

  async getCostCenterById(costCenterId: string) {
    const response = await Http.get<CostCenterApiDataWrapper<CostCenter>>(`${this.urlPath}/${costCenterId}`);

    return response.data;
  }

  async getDrivers(costCenterId: string) {
    const drivers = await Http.get<CostCenterApiDataWrapper<CostCenterDriver[]>>(`${this.urlPath}/${costCenterId}/drivers`);

    return drivers.data;
  }

  async addDriver(costCenterId: string, driver: AddDriverPayload) {
    const response = await Http.post<CostCenterApiDataWrapper<CostCenterDriver>>(`${this.urlPath}/${costCenterId}/drivers`, removeFalsyElements(driver));

    return response.data;
  }

  async removeDriver(driverHref: string) {
    await Http.delete(driverHref);
  }
}

export const costCentersService = new CostCentersService();
